<template>
  <el-container class="PageHeader">
    <div class="PageHeader-head" @click="scrollTop">
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        v-if="browserContext.up('md')"
        class="PageHeader-head-breadcrumb"
      >
        <el-breadcrumb-item
          v-for="(match, index) in breadcrumb"
          :key="breadcrumbKey(match)"
          :to="isBreadcrumbLink(index) ? breadcrumbTo(match) : undefined"
          >
          <span v-if="match.meta.title == 'Programmes'">
            {{ $t("routes.program") }}
          </span>
          <span v-else-if="match.meta.title == 'Lots'">
            {{ $t("routes.lot") }}
          </span>
          <span v-else-if="match.meta.title == 'Annonces'">
            {{ $t("routes.adsTitle") }}
          </span>
          <span v-else>
            {{
              (match.meta && match.meta.title) || match.name || match.path
            }}
          </span>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <ubi-icon
        @click="$router.go(-1)"
        name="angle-left"
        v-if="browserContext.down('sm')"
        class="PageHeader-head-back"
      />
      <h1 v-if="this.pagetitle(this.$route)">{{this.pagetitle(this.$route) }}</h1>
    </div>
    <div class="PageHeader-actions" data-test="page-header-actions">
      <slot></slot>
    </div>
  </el-container>
</template>

<script>
import { Breadcrumb, BreadcrumbItem } from 'element-ui'
import { getBreadcrumbTitleKey } from '@/helpers/breadcrumbRoutes'
import UbiIcon from '@/components/Icon.vue'

/**
 * En-tête de page
 */
export default {
  name: 'UbiPageHeader',
  components: {
    UbiIcon,
    ElBreadcrumb: Breadcrumb,
    ElBreadcrumbItem: BreadcrumbItem
  },
  inject: ['browserContext'],
  props: {
    title: String
  },
  computed: {
    breadcrumb () {
      const matched = this.$route.matched.filter(({ meta }) => !meta || !meta.root) || []
      const titleKey = getBreadcrumbTitleKey(this.$route)

      if (!titleKey) {
        return matched.slice(0, -1)
      }

      const homeMatch = matched.find((match) => match.path === '/') || matched[0]
      if (!homeMatch) {
        return matched.slice(0, -1)
      }

      return [
        homeMatch,
        {
          path: this.$route.path,
          name: `${this.$route.name}-breadcrumb`,
          meta: { title: this.$t(titleKey) }
        }
      ]
    }
  },
  methods: {
    breadcrumbKey (match) {
      return match.name || match.path || (match.meta && match.meta.breadcrumbKey)
    },
    isBreadcrumbLink (index) {
      return index < this.breadcrumb.length - 1
    },
    breadcrumbTo (match) {
      if (match.path) {
        return match.path === '/' ? { name: 'dashboard' } : match
      }
      return { name: 'dashboard' }
    },
    pagetitle (route) {
      return `${route.meta.title}` || this.title || ((this.$route.meta && this.$route.meta.title) || this.$route.name)
    },
    scrollTop () {
      if (this.browserContext.down('sm')) window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss">
@import "@/theme/_bootstrap.scss";

.PageHeader {
  align-items: center;
  justify-content: space-between;
  color: $layout-header-bg;

  &-head {
    h1 {
      @extend .mb-0, .pb-0;
      color: $layout-header-bg;
      border: 0;
    }

    &-breadcrumb {
      .el-breadcrumb__separator,
      .el-breadcrumb__inner {
        font-weight: lighter !important;
        font-size: $font-size-xs;
        color: $layout-header-bg !important;
        opacity: 0.5;
      }

      .el-breadcrumb__inner.is-link {
        cursor: pointer;
        font-weight: lighter !important;

        &:hover {
          opacity: 0.75;
        }
      }
    }
  }

  &-actions {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  @include media-breakpoint-up(md) {
    margin-top: map-get($spacers, 3);
    margin-bottom: map-get($spacers, 3);
  }

  @include media-breakpoint-down(md) {
    flex-direction: column;

    &-head {
      align-self: flex-start;

      h1 {
        margin-bottom: map-get($spacers, 0) !important;
        padding-bottom: 0 !important;
      }
    }

    &-actions {
      align-self: flex-end;
    }
  }

  @include media-breakpoint-down(sm) {
    color: $layout-header-bg;

    &-head {
      height: 50px;
      align-items: center;
      border-bottom: 1px solid rgba($layout-header-bg, 0.2);
      display: flex;
      justify-content: flex-start;
      padding: map-get($spacers, 2);
      width: 100%;

      h1 {
        font-size: $font-size-base-alt;
        border-bottom: 0;
        margin: 0 !important;
        padding: 0 !important;
      }

      &-back {
        align-items: center;
        display: flex;
        height: 36px;
        justify-content: center;
        margin-right: map-get($spacers, 3);
        width: 36px;
      }
    }

    &-actions {
      padding: map-get($spacers, 3);
      text-align: right;
      width: 100%;

      .el-button {
        padding-top: map-get($spacers, 2);
        padding-bottom: map-get($spacers, 2);
      }
    }
  }
}
/* Pour IPAD PRO */
@media screen and (min-width: 1024px) and (max-width: 1366px) {
  .PageHeader{
    padding-left: 10px;
    padding-right: 10px;
  }
}
</style>
